import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function IndexPageHeader() {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <Box
            width="100%"
            sx={{
                minHeight: isMobile ? '100vh' : '80vh',
                background: 'linear-gradient(160deg, #000000 0%, #1a0000 50%, #242331 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Grid container maxWidth="lg" spacing={2} p={3} mt={isMobile ? 6 : 0} justifyContent="center">
                <Grid item size={{ xs: 12, md: 10 }} textAlign="center">
                    <Typography
                        component="h1"
                        color="grey.100"
                        sx={{ typography: { xs: 'h3', md: 'h1' }, mb: 2 }}
                        fontWeight="bold"
                    >
                        Cloud Security for Everyone.
                    </Typography>
                    <Typography
                        component="h2"
                        color="prevailRed.main"
                        sx={{ typography: { xs: 'h6', md: 'h4' }, mb: 3 }}
                        fontWeight="bold"
                    >
                        Detect Active Threats in Under 1 Minute.
                    </Typography>
                    <Typography
                        variant="h6"
                        color="grey.400"
                        sx={{ maxWidth: '700px', mx: 'auto', lineHeight: 1.8, mb: 5 }}
                    >
                        PREVAIL uses proprietary AI to detect breaches against your Microsoft 365 tenant
                        the moment they happen — without complex configuration, without a security team,
                        and without breaking the budget.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mb: 6 }}>
                        <Link to="https://app.prevailcyber.com/sign-up" target="_blank">
                            <Button
                                variant="contained"
                                color="prevailRed"
                                size="large"
                                sx={{ pl: 5, pr: 5, py: 1.5 }}
                            >
                                <Typography sx={{ fontSize: '1.1em' }} color="grey.100">
                                    Start for Free
                                </Typography>
                            </Button>
                        </Link>
                        <Link to="#contact">
                            <Button
                                variant="outlined"
                                size="large"
                                sx={{ pl: 4, pr: 4, py: 1.5, borderColor: 'grey.600', color: 'grey.300' }}
                            >
                                <Typography sx={{ fontSize: '1.1em' }}>Contact Us</Typography>
                            </Button>
                        </Link>
                    </Box>

                    <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: '750px', mx: 'auto' }}>
                        {[
                            'Microsoft 365 threat detection',
                            'Connected in under 3 minutes',
                            'No security team required',
                            'Starting at $3/user/month',
                        ].map((item) => (
                            <Grid item xs={6} md={3} key={item}>
                                <Box display="flex" alignItems="center" gap={0.75} justifyContent="center">
                                    <CheckCircleIcon sx={{ color: '#d90000', fontSize: 16 }} />
                                    <Typography variant="caption" color="grey.400" sx={{ fontSize: '0.85em' }}>
                                        {item}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
